import { render, staticRenderFns } from "./LookalikeInfluencers.vue?vue&type=template&id=73fe5c63&scoped=true&"
import script from "./LookalikeInfluencers.vue?vue&type=script&lang=js&"
export * from "./LookalikeInfluencers.vue?vue&type=script&lang=js&"
import style0 from "./LookalikeInfluencers.vue?vue&type=style&index=0&id=73fe5c63&lang=scss&scoped=true&"
import style1 from "./LookalikeInfluencers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe5c63",
  null
  
)

export default component.exports